import React from 'react'
import { useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { useAuth } from 'lib/auth'
import { useStyles } from 'pages/pga-coach/bookings/events/edit/edit-event-form/styles'
import YesNoSegmentControl from './yes-no-segment-control'

const CreateEventWaitlist = () => {
  const classes = useStyles()
  const { watch } = useFormContext()
  const { user } = useAuth()
  const tags = watch('tags')
  const maxAttendance = watch('maxAttendance')
  const hasPaidTierSubscription = user?.coach?.hasPaidTierSubscription
  const isPgaHopeEvent = tags?.includes('PGA HOPE')
  const showWaitlistOption =
    (hasPaidTierSubscription || isPgaHopeEvent) &&
    maxAttendance !== null &&
    maxAttendance !== undefined &&
    maxAttendance !== ''

  if (!showWaitlistOption) return null

  return (
    <Box className={classes.fieldGroup}>
      <Typography className={classes.sectionHeading}>Waitlist</Typography>
      <Typography className={classes.fieldHelper}>
        Collect a waitlist and contact students if a spot becomes available.
      </Typography>
      <YesNoSegmentControl
        name="waitlistEnabled"
        ariaLabel="Waitlist"
        data-cy="waitlistToggle"
      />
    </Box>
  )
}

export default CreateEventWaitlist
